import { render, staticRenderFns } from "./SendError1Window.vue?vue&type=template&id=79e7f5fa&scoped=true"
import script from "./SendError1Window.vue?vue&type=script&lang=js"
export * from "./SendError1Window.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7f5fa",
  null
  
)

export default component.exports